import { render, staticRenderFns } from "./NotesComponent.vue?vue&type=template&id=2d42d0e2&scoped=true&"
import script from "./NotesComponent.vue?vue&type=script&lang=js&"
export * from "./NotesComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotesComponent.vue?vue&type=style&index=0&id=2d42d0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d42d0e2",
  null
  
)

export default component.exports